import React, { useState } from 'react';
import Truncate from 'react-truncate';
import { Tooltip as TooltipUIKit } from 'syngenta-digital-cropwise-react-ui-kit';
import CropIconMapping from 'components/CropIconMapping';
import LayoutStrings from 'screens/Applications&WorkOrders/StepsLayout/Constants/layoutStrings';
import { CropZoneRecord } from './types';

export const Tooltip: React.FC<{
  title: string;
  placement?: 'top' | 'bottom' | 'left' | 'right';
  children: React.ReactNode;
}> = ({ title, placement = 'top', children }) => (
  <TooltipUIKit
    title={title}
    placement={placement}
    color="#232630"
    align={{ offset: [0, 6] }}
  >
    {children}
  </TooltipUIKit>
);

export const ArchivedTag: React.FC = () => (
  <span style={{ whiteSpace: 'nowrap' }}>
    {' '}
    {LayoutStrings.cropZones.archived}
  </span>
);

export const PropertyNameCell: React.FC<{ record: CropZoneRecord }> = ({
  record
}) => {
  const [isTruncated, setIsTruncated] = useState(false);
  return (
    <div className="max-w-full">
      <Tooltip
        title={isTruncated ? record.propertyName || '' : ''}
        placement="top"
      >
        <Truncate
          lines={2}
          ellipsis={
            <span>…{record.isPropertyArchived && <ArchivedTag />}</span>
          }
          onTruncate={setIsTruncated}
        >
          {record.propertyName}
          {!isTruncated && record.isPropertyArchived && <ArchivedTag />}
        </Truncate>
      </Tooltip>
    </div>
  );
};

export const CropZoneNameCell: React.FC<{ record: CropZoneRecord }> = ({
  record
}) => {
  const [isFieldTruncated, setIsFieldTruncated] = useState(false);
  const [isCropZoneTruncated, setIsCropZoneTruncated] = useState(false);
  return (
    <div className="py-6px">
      <div className="text-neutral-60 max-w-full">
        <Tooltip
          title={isFieldTruncated ? record.fieldName || '' : ''}
          placement="top"
        >
          <Truncate
            lines={1}
            ellipsis={
              <span title={record.fieldName}>
                …{record.isFieldArchived && <ArchivedTag />}
              </span>
            }
            onTruncate={setIsFieldTruncated}
          >
            {record.fieldName}
            {!isFieldTruncated && record.isFieldArchived && <ArchivedTag />}
          </Truncate>
        </Tooltip>
      </div>
      <div className="max-w-full">
        <Tooltip
          title={isCropZoneTruncated ? record.name || '' : ''}
          placement="top"
        >
          <Truncate
            ellipsis={<span title={record.name}>…</span>}
            onTruncate={setIsCropZoneTruncated}
          >
            {record.name}
          </Truncate>
        </Tooltip>
      </div>
    </div>
  );
};

export const CropCell: React.FC<{ record: CropZoneRecord }> = ({ record }) => {
  const [isTruncated, setIsTruncated] = useState(false);
  if (!record.crop) {
    return <div />;
  }
  return (
    <div className="items-start flex">
      <div style={{ flex: '0 0 auto' }} className="mr-1">
        <CropIconMapping cropObject={record.crop} size={18} />
      </div>
      <div
        className="flex items-center min-w-0 whitespace-normal wrap-break-word"
        style={{
          flex: '1 1 0',
          minHeight: '18px'
        }}
      >
        <Tooltip title={isTruncated ? record.crop.name : ''} placement="top">
          <Truncate
            lines={2}
            ellipsis={<span title={record.crop.name}>…</span>}
            onTruncate={setIsTruncated}
          >
            {record.crop.name}
          </Truncate>
        </Tooltip>
      </div>
    </div>
  );
};
